import type { WidgetConfig } from '@/domain/WidgetConfig';
import options from './options.json';
import translations from './translations.json';

export type TechOptions = {
  appearance: {
    mainHeading: string;
    heading: string;
    smallHeading: string;
    backgroundTheme: 'light' | 'dark';
  };
  cta: HeroBannerCTA | {};
  images: {
    desktopImage: string;
    tabletImage: string;
    mobileImage: string;
  };
  modal: ModalOptions;
  tracking: TrackingOptions;
};

export type HeroBannerCTA = {
  ctaType: 'modal' | 'link' | 'none';
  ctaLabel: string;
  ctaLink: string;
  ctaTarget: '_self' | '_blank';
};

export type TrackingOptions = {
  promotionId: string;
  promotionName: string;
  creativeName: string;
};

export type ModalOptions = {
  heading: string;
  description: string;
  image: {
    desktopImage: string;
    tabletImage: string;
    mobileImage: string;
  };
  cta: {
    ctaLabel: string;
    ctaLink: string;
    ctaTarget: '_self' | '_blank';
  };
};

export type Config = {
  translations: WidgetConfig['translations'];
  options: TechOptions;
};

export type Translations = typeof translations;
export const defaultTranslations = translations;
export const defaultOptions = options;
